import './App.css'

function App() {

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h1>ScottClub</h1>
        <a href='politica'>Política de Privacidade</a>
        <a href='deluser' style={{ color: 'tomato' }}>Apagar conta</a>
      </div>
    </>
  )
}

export default App
